import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UserService } from '../services/user.service';

import { fadeInUp } from '../services/animations/fadeInUp.animation'

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    animations: [fadeInUp]
})
export class ProfilePageComponent implements OnInit {
    routeId: any
    currentUser: any

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private title: Title,
        private userService: UserService
    ) {
        this.routeId = this.route.snapshot.params['page'];
        this.router.events.filter((event) => event instanceof NavigationEnd).map(() => this.route).map((route) => {
            while (route.firstChild) route = route.firstChild;
            return route;
        }).filter((route) => route.outlet === 'primary').mergeMap((route) => route.data).subscribe((event) => {
            this.routeId = this.route.snapshot.params['page'];
            if (this.routeId === 'reviews') {
                this.title.setTitle('Most Recent Reviews | My Profile');
            } else if (this.routeId === 'notifications') {
                this.title.setTitle('Notifications | My Profile');
            } else {
                this.title.setTitle('My Profile | Get Above');
            }
        });
    }

    ngOnInit() {
        this.userService.getCurrentUser()
        this.userService.currentUser.subscribe((currentUser) => {
            this.currentUser = currentUser
        })
    }

    logout() {
        this.userService.logout();
    }
}



// WEBPACK FOOTER //
// ./src/app/user/profile.component.ts